export const fragenPickerlgutachtenTuevGuide = [
  {
    question: "Kann ich das Pickerl nach Ablauf der Frist noch machen lassen?",
    answer: (
      <>
        <p>
          Ja, aber du riskierst bei einer Verkehrskontrolle ein Bußgeld, und die
          Versicherung kann bei Unfällen Regressforderungen stellen.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich die Plakette sichtbar anbringen?",
    answer: (
      <>
        <p>
          Die Prüfplakette wird vom Prüfer am hinteren Kennzeichen befestigt.
          Sie darf nicht entfernt werden.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich die Begutachtung auch im Ausland machen?",
    answer: (
      <>
        <p>
          Nein. Die § 57a‑Begutachtung ist eine nationale Regelung in Österreich
          und muss in Österreich durchgeführt werden.
        </p>
      </>
    ),
  },
  {
    question: "Wie finde ich eine seriöse Prüfstelle?",
    answer: (
      <>
        <p>
          Zugelassene Werkstätten und Prüfstellen sind vom Bundesministerium
          zertifiziert. Achte auf entsprechende Plaketten und Lizenzen.
        </p>
      </>
    ),
  },
];

